import { createFilterOptions } from '@mui/material/Autocomplete'

import { FilterOptionsState, OptionProps } from './Helper'
import { validateInput } from './LanguageValidationUtils'
import { MAX_PARTICIPANT_TAGS_CHAR } from 'lib/GlobalConstants'
import { Tag } from 'containers/TextAnalysis/Types'

// Create a default filter function
const filter = createFilterOptions<OptionProps>()

export const filterOptions = (
  options: (string | OptionProps)[] | any,
  params: FilterOptionsState<OptionProps>,
  tagLabel: string,
  selectedTags: (string | OptionProps)[] = [],
  allowCreateTag: boolean,
) => {
  const { inputValue } = params
  const normalizedInput = inputValue.trim().toLowerCase()
  const filtered = filter(options, params)

  // Check if the input already exists in the options
  const isExisting = options.some((option: string | OptionProps) =>
    typeof option === 'string'
      ? normalizedInput === option.toLowerCase()
      : normalizedInput === option?.[tagLabel].toLowerCase(),
  )

  // Add an option to create a tag if the input is new
  if (normalizedInput && !isExisting && allowCreateTag) {
    filtered.push({ title: normalizedInput, createTag: true })
  }

  // Final filtering to exclude already selected options
  return filtered.filter((option) => {
    // Determine the display label for each option
    const optionLabel =
      typeof option === 'string' ? option : option[tagLabel] || option.title
    const normalizedLabel = optionLabel.toLowerCase()

    // Check if the option is already selected
    const isSelected = selectedTags.some((tag: string | OptionProps) => {
      const selectedLabel = typeof tag === 'string' ? tag : tag?.[tagLabel]
      return selectedLabel?.toLowerCase() === normalizedLabel
    })

    // Include the option if it's not selected and matches the input
    return !isSelected && normalizedLabel.includes(normalizedInput)
  })
}

export const getTagLabel = (option: any, tagLabel: string) => {
  if (typeof option === 'object' && option[tagLabel]) {
    return option[tagLabel]
  } else if (typeof option === 'object' && option.createTag) {
    return option.title
  } else if (typeof option === 'string') {
    return option
  }
  return ''
}

export const mapTagsToLabels = (
  tags: (string | OptionProps)[],
  tagLabel: string,
): string[] => {
  return tags.map((tag) => getTagLabel(tag, tagLabel))
}

export const updateTagItem = (array: any[] = [], tag: string | Tag) => {
  return array.includes(tag) ? array.filter((i) => i !== tag) : [...array, tag]
}

export const validateTagMenuTags = (
  value: string,
  setInputValue: (args0: string) => void,
) => {
  const cleanValue = value.toLowerCase().replace(/\s+/g, ' ')

  if (cleanValue.length > MAX_PARTICIPANT_TAGS_CHAR) {
    return false
  } else if (cleanValue.length === 0) {
    setInputValue('')
    return false
  } else if (validateInput(cleanValue)) {
    setInputValue(cleanValue)
    return true
  }
  return false
}
